<template>
    <div>

        <div v-for="data in list_data" :key="data.idx">
        <!-- slider Area Start-->
            <div class="slider-area ">
                <!-- Mobile Menu -->
                <div class="single-slider slider-height2 d-flex align-items-center" data-background="img/ekokrafdetile.jpg">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="hero-cap text-center">
                                    <h2>{{data.brand}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- slider Area End-->
        <div class="favourite-place place-padding" style="margin-top: -5%">
            <div class="container">
            <!-- Section Tittle -->

        
            <br>
            

                <div class="row">
                    <div class="col-lg-8 posts-list">
                    <div class="single-post">
                        <div class="feature-img">
                            <!-- <img class="img-fluid" src="assets/img/blog/single_blog_1.png" alt=""> -->
                            <center>
                              <img class="img-fluid" style="width:70%; height: 400px;" :src="$store.state.url.URL_APP+'uploads/'+data.file" alt="">
                            </center>
                        </div>
                        <div class="blog_details">
                            <h2>{{data.uraian}}</h2>
                            <ul class="blog-info-link mt-3 mb-4">
                                <li><a href="#"><i class="fa fa-university"></i> Penjual : {{data.ekokrafpelaku_pelaku}}</a></li>
                                <li><a href="#"><i class="fa fa-calendar"></i> {{ new Date(data.editedAt).toDateString() }}</a></li>
                            </ul>
                            
                            <div class="ql-editor" v-html="UMUM.replaceEscapeString(data.keterangan)"></div>
                        </div>
                    </div>

                    <br>
                    <div class="blog-author">
                        
                        <div class="row">
                            <div class="col-2">
                              <a target="_blank" :href="'https://wa.me/'+data.ekokrafpelaku_hp+'?text=Halo kak, saya mau order %0A%0A' + data.brand">
                                <img class="img-fluid button-image" src="img/contact-us.png"   alt="">

                              </a>
                               
                            </div>
                            <div class="col-10">
                                <span class="h_kecil_title">Email : {{data.ekokrafpelaku_email}}</span> <br>
                                <span class="h_kecil_title">No. Telepon : {{data.ekokrafpelaku_hp}}</span> <br>
                                <span class="h_kecil_title">Alamat : {{data.ekokrafpelaku_alamat}}</span> <br>
                                <span class="h_kecil_title">Badan Usaha : {{data.ekokrafpelaku_badan_usaha}}</span> <br>
                            </div>
                        </div>
                    </div>

                    </div>
                    <div class="col-lg-4">
                    <div class="blog_right_sidebar">

                        <aside class="single_sidebar_widget post_category_widget">
                            <h4 class="widget_title">Keterangan</h4>
                            <ul class="list cat-list">
                                <li v-for="datax in list_data" :key="datax.id">
                                    
                                    <p>Harga : {{datax.harga}}</p>
                                    <p>Stok : {{ datax.stock }}</p>
                                    
                                </li>
                            
                            </ul>
                        </aside>


                        <destinasiLainnya/>

                        <fotoLainnya/>



                    </div>
                    </div>
                </div>


            <hr>


            </div>
        </div>

            <!-- <script type="application/javascript" defer src="./assets/js/vendor/jquery-1.12.4.min.js"></script> -->


            <script type="application/javascript" defer src="./assets/js/plugins.js"></script>
            <script type="application/javascript" defer src="./assets/js/main.js"></script>
        </div>
    </div>
</template>

<script>


import FETCHING from  '../../library/fetching'
import UMUM from  '../../library/umum'
import { gmapApi } from 'vue2-google-maps';

export default {
  data() {
    return {
        idx : '',
        list_data : [],
        list_data_fasilitas : [],
    
        list_jenis_wisata : [],
        bidangPariwisata : 2,



        m_jenisPariwisata : '',

        FETCHING : FETCHING,
        UMUM : UMUM,


        loadJenis : false
    }
  },

  methods: {
    getView: function() {
      fetch(this.$store.state.url.URL_EKOKRAF_PELAKU_PRODUK + "getOne", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify({
          keyx : this.idx,
        })
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_data = res_data;
            console.log(res_data);


        });
    },




    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },

    fetcher : async function() {
      this.loadJenis = false
      this.list_jenis_wisata = await FETCHING.FETCH_POST(
        this.$store.state.url.URL_JENIS_WISATA + "list", 
        {bidangPariwisata : this.bidangPariwisata}
      )

      this.loadJenis = true

      // console.log(this.list_jenis_wisata)
    }
  },
  computed: {
      google: gmapApi
  
    },

  mounted () {

    this.idx = window.location.search.split('idx=')[1];
    // this.idx = window.location.search;
    console.log(`Current URL => ${this.idx}`);




    this.fetcher()
    this.getView();
    
  },
  

};
</script>

<style>
.button-image {
    animation: updown 2s ease infinite;
}
@keyframes updown {
  0% {
    transform: translateY(-20%);
  }

  50% {
    transform: translateY(20%);
  }

  100% {
    transform: translateY(-20%);
  }
}
</style>